import { BaseHook } from './base.hook';

export class OnBlurHook extends BaseHook {

  static path = 'blur';

  static execute(path, value, actions) {
    const blurValue = actions.getData(value);
    if (value === 'DepositFunds.amount') {
      let amount = blurValue;
      amount = parseFloat(amount).toFixed(2);
      if (amount !== 'NaN' && amount != null) {
        const [whole, decimal] = amount.split('.');
        if (decimal === '00') {
          actions.setData('DepositFunds.amount', whole);
        } else {
          actions.setData('DepositFunds.amount', amount);
        }
      }
    }

    if (blurValue != null && blurValue.trim() !== blurValue) {
      actions.setData(value, blurValue.trim());
    }
  }
}
